import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { usePermissions } from "../context/PermissionContext";

const ClientPlanStatusModal = ({ onClose,clientPlanStatus }) => {
  const navigate = useNavigate();
  const {
    hasPermission,
  } = usePermissions();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/sign-in");
    if (onClose) onClose();
  };
  return (
    <>
      <style>
        {`
         /* Subscription Expired Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: var(--white);
  border-radius: var(--rounded-12);
  padding: var(--size-32);
  max-width: 32rem;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-2);
  position: relative;
}

.modal-content h3 {
  font-size: var(--font-xl);
  font-weight: 600;
  color: var(--text-primary-light);
  margin-bottom: var(--size-16);
}

.modal-content p {
  font-size: var(--font-md);
  color: var(--text-secondary-light);
  margin-bottom: var(--size-24);
}

.modal-content .button-container {
            display: flex;
            justify-content: center;
            gap: var(--size-16);
          }

          .modal-content .renew-button,
          .modal-content .logout-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: var(--size-8);
            padding: var(--size-12) var(--size-24);
            border: none;
            border-radius: var(--rounded-8);
            font-size: var(--font-md);
            font-weight: 500;
            text-decoration: none;
            transition: background 0.3s ease;
          }

          .modal-content .renew-button {
            background: var(--primary-600);
            color: var(--white);
          }

          .modal-content .renew-button:hover {
            background: var(--primary-700);
          }

          .modal-content .logout-button {
            background: var(--danger-600);
            color: var(--white);
          }

          .modal-content .logout-button:hover {
            background: var(--danger-700);
          }

          .modal-content .close-button {
            position: absolute;
            top: var(--size-16);
            right: var(--size-16);
            background: none;
            border: none;
            font-size: var(--font-lg);
            color: var(--neutral-500);
            cursor: pointer;
          }

          .modal-content .close-button:hover {
            color: var(--primary-600);
          }

@media (max-width: 768px) {
  .modal-content {
    padding: var(--size-24);
    margin: var(--size-16);
  }
  .modal-content h3 {
    font-size: var(--font-lg);
  }
  .modal-content p {
    font-size: var(--font-sm);
  }
    .modal-content .button-container {
              flex-direction: column;
              gap: var(--size-12);
            }
}
        `}
      </style>
      <div className="modal-overlay">
        <div className="modal-content">
         <h3>
            {clientPlanStatus?.plan_name
              ? `${clientPlanStatus.plan_name}`
              : "Subscription Expired"}
          </h3>

          {/* ---- DYNAMIC DESCRIPTION ---- */}
          <p>
            {clientPlanStatus ? (
              <>
                Your current plan <strong>{clientPlanStatus.plan_name}</strong>{" "}
                allows <strong>{clientPlanStatus.max_vehicles_allowed}</strong>{" "}
                vehicles.
                <br />
                You have parked{" "}
                <strong>{clientPlanStatus.parked_till_now}</strong> vehicles so far.
                {/* <br />
                Limit Type:{" "}
                <strong style={{ textTransform: "capitalize" }}>
                  {clientPlanStatus.limit_type}
                </strong> */}
                <br />
                {clientPlanStatus.is_plan_fully_used ? (
                  <span style={{ color: "var(--danger-600)", fontWeight: 600 }}>
                    Your plan limit has been fully used. Please upgrade.
                  </span>
                ) : (
                  <span style={{ color: "var(--primary-600)", fontWeight: 500 }}>
                    Your plan is active but expired. Please renew to continue.
                  </span>
                )}
              </>
            ) : (
              "Your subscription has expired. Please renew to continue accessing all features."
            )}
          </p>
          <div className="button-container">
            {hasPermission("view_subscription") && (
            <Link to="/subscription" className="renew-button">
              <Icon icon="mdi:refresh" />
              Upgrade Plan
            </Link>)}
            <button
              type="button"
              className="logout-button"
              onClick={()=>navigate(-1)}
            >
              <Icon icon="mdi:arrow-left" />
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientPlanStatusModal;
